// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const CheckoutClient = registerClientReference(
    function() { throw new Error("Attempted to call CheckoutClient() from the server but CheckoutClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(buyer)/checkout/checkout-client.tsx",
    "CheckoutClient",
);
